var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffc051;stroke:#707070;opacity:0;}.b{fill:#d263e4;stroke:#d263e4;stroke-width:0.5px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335 308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.167,8.333a4.167,4.167,0,1,1,4.167-4.167A4.171,4.171,0,0,1,8.167,8.333Zm0-7.5A3.333,3.333,0,1,0,11.5,4.167,3.337,3.337,0,0,0,8.167.833Z",
    transform: "translate(-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.417,19.5h-5A.417.417,0,0,1,0,19.083V15.75A3.755,3.755,0,0,1,3.75,12h7.5a3.734,3.734,0,0,1,2.7,1.155.417.417,0,1,1-.6.573,2.9,2.9,0,0,0-2.1-.9H3.75A2.92,2.92,0,0,0,.833,15.75v2.917H5.417a.417.417,0,0,1,0,.833Z",
    transform: "translate(0 -12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5 13.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.583,22.667a.416.416,0,0,1-.372-.23l-1.552-3.1H9.417a.417.417,0,1,1,0-.833h2.5a.417.417,0,0,1,.373.23l1.265,2.53L15.7,16.252A.417.417,0,0,1,16.071,16a.438.438,0,0,1,.385.23L18.841,21h2.243a.417.417,0,0,1,0,.833h-2.5a.417.417,0,0,1-.373-.23l-2.1-4.2-2.146,5.007a.417.417,0,0,1-.371.253h-.013Z",
    transform: "translate(-9 -16)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.dd5ab87ed743823010d2f7f796f51908.svg";
export { ForwardRef as ReactComponent };